<template>
  <div class="sb_screen-login">
    <div class="sb_screen-login_content">
      <h2>Inloggen</h2>
      <form @submit.prevent="login">
        <input v-model="name" placeholder="Naam" />
        <input type="password" v-model="password" placeholder="Wachtwoord" />

        <div v-if="error" class="sb_screen-login_error-message">
          {{ error }}
        </div>

        <button type="submit">Login</button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handleError } from "@/lib/errorHandling";

export default {
  data() {
    return {
      name: "",
      password: "",
      error: null,
    };
  },

  methods: {
    async login() {
      this.error = null;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_BACKEND_BASE_URL}users/login`,
          {
            name: this.name,
            password: this.password,
          }
        );
        console.log(res);
        const data = res.data;
        const token = data.token;
        localStorage.setItem("token", token); // Store token in localStorage
        this.$router.push("/");
      } catch (error) {
        console.log({ error });
        if (error.response && error.response.data && error.response.data.slug) {
          const errorSlug = error.response.data.slug;
          console.log({ errorSlug });

          if (errorSlug === "no-user-found") {
            this.error = "Deze gebruiker kon niet worden gevonden.";
            return;
          }
          if (errorSlug === "invalid-credentials") {
            this.error = "Inloggegeven incorrect. Probeer het opnieuw.";
            return;
          }
        }
        handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sb_screen-login {
  display: flex;
  justify-content: center;
  padding: 2rem;

  &_error-message {
    color: var(--error-500);
  }

  &_content {
    max-width: 400px;
    background: var(--white);
    padding: 2rem;
    border-radius: 1rem;
    margin-top: 10vh;

    h2 {
      margin: 0 0 0.5rem 0;
    }

    input {
      padding: 0.5rem 1rem 0.5rem 1rem !important;
      height: rem-calc(60) !important;
      font-size: 1.5rem !important;
      background-color: var(--gray-050) !important;
      margin: 0 0 0.5rem 0;
    }

    button {
      margin: 1rem 0 0 0;
      margin: 1rem 0 0 0;
      font-size: 1.6rem !important;
      background: var(--gray-500);
      color: var(--white);
      padding: 1rem 2rem;
    }
  }
}
</style>
